import { UseMutationResult, useQueryClient } from '@tanstack/react-query';
import { useSession } from '../../SessionProvider';
import { deleteBookmark } from './deleteBookmark';

import { useTrackedMutation as useMutation } from '@ais-ui/performance-tracking';

export const useDeleteBookmark = (): UseMutationResult<
  unknown,
  Error,
  string,
  null
> => {
  const { olSession } = useSession();
  const queryClient = useQueryClient();

  return useMutation(
    (id: string) => {
      return deleteBookmark(olSession, id);
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['getBookmarks']);
      },
    }
  );
};
